import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext, useMemo } from 'react';
import { OptionGroupContext } from './context.js';
import { FormInputOption } from '@tesla/design-system-react';

var _excluded = ["value", "label", "disabled", "description", "required"];

/**
 * @typedef {Object} OptionProps
 * @property {*} props.value
 * @property {String} props.label
 * @property {String} [props.description]
 * @property {Boolean} [props.required]
 * @property {Boolean} [props.disabled]
 */

/**
 * Render an option
 *
 * @param {OptionProps} props
 */
function Option(_ref) {
  var value = _ref.value,
    label = _ref.label,
    optionDisabled = _ref.disabled,
    description = _ref.description,
    required = _ref.required,
    userProps = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(OptionGroupContext);
  if (typeof context === 'undefined') {
    throw new Error('<Option> should be rendered inside of a <OptionGroup> component');
  }
  var optionGroupContext = context.optionGroupContext,
    optionGroupHandler = context.optionGroupHandler;
  var groupValue = optionGroupContext.value,
    groupDisabled = optionGroupContext.disabled;
  var multiselect = optionGroupContext.multiselect;
  var disabled = groupDisabled !== null && groupDisabled !== void 0 ? groupDisabled : optionDisabled;
  var id = "".concat(optionGroupContext.id, "-").concat(optionGroupContext.name, "_").concat(value);
  var checked = multiselect ? Array.isArray(groupValue) && !Array.isArray(value) && groupValue.indexOf(value) !== -1 : groupValue === value;
  var render = useMemo(function () {
    return /*#__PURE__*/React.createElement(FormInputOption, _extends({
      type: multiselect ? 'checkbox' : 'radio'
    }, optionGroupHandler, userProps, {
      showVisualCheckbox: multiselect
      // Because leading is not default for multiselect labels TDS issue ?
      ,
      leading: multiselect ? label : userProps.leading,
      checked: checked,
      label: !multiselect ? label : undefined,
      value: value,
      disabled: disabled
    }));
  }, [value, label, required, id, disabled, description, checked]);
  return render;
}

export { Option };
